import storefront from "../storefront/index";
import * as queries from "../storefront/queries";
import unwrapNodes from "../unwrapNodes";

let cache = null;

export default function fetchGuideData() {
  if (cache) {
    return cache;
  }

  cache = storefront
    .request({
      query: queries.getCertifiedGuidesData,
      variables: {
        input: {
          handle: "main",
          type: "certified_guides",
        },
      },
    })
    .then(({ data }) => {
      return unwrapNodes(data.metaobject);
    });

  return cache;
}
